<section class="my-0">
  <div class="{{alertStyle}} mb-3" *ngIf="isLoginError" role="alert">
    <p>
      <i class="{{alertIconStyle}} fa-2x float-left mx-2" aria-hidden="true"></i>
      {{alertMessage }}
    </p>
    <ng-container *ngIf="!!adminsList.length">
      <div style="margin-left:2.875rem">
        Your NESS Application Administrators are:
        <ul class="mt-2">
          <li *ngFor="let admin of adminsList">{{ admin.FirstName.replaceAll("+"," ") }} {{ admin.LastName.replaceAll("+"," ") }} (<a href="mailto:{{admin.UserName}}?subject=NESS Account support request">{{admin.UserName}}</a>)</li>
        </ul>
      </div>
    </ng-container>
  </div>
  <div style="align-items: center; text-align: center;">
    <p-messages key="defaultMsg" [closable]="true"></p-messages>
    <div>
      <span class="fw-bold"><i class="fas fa-exclamation-circle fa-md text-primary me-2" aria-hidden="true"></i>NEW USERS</span>
    </div>
    <div>
      <p></p>
      <div><span class="fw-bold">ATF USERS:</span> Click on the Login button and follow the registration prompts.</div>
      <div><span class="fw-bold">OTHER (NON-ATF) LAW ENFORCEMENT USERS:</span> Contact your local ATF office for access.</div>
      <p></p>
      <p> Direct questions to your local ATF CGIC point of contact or email <a href="mailto:NESS_Support@atf.gov" title="Open a blank email to contact NESS support.">NESS_Support&#64;atf.gov.</a></p>
      <p>&nbsp;</p>
    </div>
    <div>
      <a class="btn btn-primary px-5" href="{{dojloginUri}}">Login</a>
    </div>
  </div>
</section>
